import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { IOption } from "@evergis/ui";

import { wrapToQuotes } from "./useAdvancedEditor";

export const useSelectAttribute = () => {
  const [attributeOption, setAttributeOption] = useState(null);
  const [attributeValue, setValue] = useState(null);
  const [templateValue, setTemplateValue] = useState(null);

  useEffect(() => {
    templateValue !== null && templateValue !== "" && setValue(templateValue);
  }, [templateValue, setValue]);

  const onChangeAttribute = useCallback(
    (option: IOption[]) => {
      setAttributeOption(option[0]);
    },
    [setAttributeOption],
  );

  const onChangeAttributeValue = useCallback(
    (inputValue: ChangeEvent<HTMLInputElement> | number | string) => {
      if (typeof inputValue === "number" || typeof inputValue === "string") {
        setValue(inputValue);
      } else {
        setValue(wrapToQuotes(inputValue?.target.value || ""));
      }
    },
    [setValue],
  );

  const resetAttributeValue = useCallback(() => setValue(null), [setValue]);

  const handleSetTemplateValue = useCallback(
    (value: string) => {
      setTemplateValue(value);
    },
    [setTemplateValue, templateValue],
  );

  return {
    onChangeAttribute,
    onChangeAttributeValue,
    attributeOption,
    attributeValue,
    templateValue,
    handleSetTemplateValue,
    resetAttributeValue,
  };
};
